<template>
    <section>
        <div class="content">
            <table class="table is-size-5 is-striped">
                <thead>
                    <tr>
                        <th>Log</th>
                        <th>Download</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>All</td>
                        <td><a class="button is-dark greyBG has-text-weight-normal"
                                href="http://api.sensesmart.in:8888/emqx.log.1" target="_blank">Download</a>
                        </td>
                    </tr>
                    <tr :key="key" v-for="(log, key) in logs">
                        <td>{{log}}</td>
                        <td><a class="button is-dark greyBG has-text-weight-normal"
                                :href="'http://api.sensesmart.in:8888/'+log+'.log.1'" target="_blank">Download</a></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </section>
</template>
<script>
const logs = ['debug', 'info', 'notice', 'warning', 'error', 'critical', 'alert', 'emergency']
const selectedLogs = ['info', 'error']
export default {
    data(){
        return{
            logs: selectedLogs
        }
    }
}
</script>
<style scoped>
td{
  text-align: center !important;
}

th{
  text-align: center !important;
}
</style>

